import type { AddressType } from '~~/types/AddressType';
import type { VatNumber } from '~~/helpers/cart/customFields';

export default (addressType: AddressType) => {

  const vatNumber = useState<VatNumber>(`${addressType}VatNumber`, () => '');
  const setVatNumber = async (value: VatNumber) => {

    if (vatNumber.value === value) {

      return;

    }
    vatNumber.value = value;
  
  };

  return {
    vatNumber,
    setVatNumber,
  };

};
